import Vue from 'vue';
import VueCookies from 'vue-cookies-ts';
import App from './App.vue';
import router from './router';
import store from './store';
import vuetify from './plugins/vuetify';
import * as RouterPath from './classification/RouterPath';

Vue.config.productionTip = false;
Vue.use(VueCookies);

new Vue({
  router,
  store,
  vuetify,
  render: (h) => h(App),
  data: {
    title: 'てすと',
  },
  methods: {
    // eslint-disable-next-line object-shorthand
    createPageTitle: function (to: any) {
      if (to.meta.title !== undefined) {
        document.title = to.meta.title;
      }
    },
  },
  watch: {
    // eslint-disable-next-line object-shorthand
    '$route'(to: any, _) {
      this.createPageTitle(to);
    },
  },
}).$mount('#app');

/**
 * 各画面でのTab無効化を行う
 * 会員情報登録と会員情報更新は例外として許可する
 *
 * @param e イベント
 */
window.onkeydown = function (e: any) {
  // eslint-disable-next-line no-restricted-globals
  if (location.pathname === RouterPath.ENTRY || location.pathname === RouterPath.UPDATE_INFO) return true;

  if (e.keyCode === 9) {
    return false;
  }
  return true;
};
